import { UnstablePublicApi } from '../Interface/Unstable';
import { createVideoHandler } from './GlobalVideo';

export const unstable: UnstablePublicApi = {
    createVideoHandler,
};
